import { render, staticRenderFns } from "./marketCourseContent.vue?vue&type=template&id=2e9e6c4b&scoped=true&"
import script from "./marketCourseContent.vue?vue&type=script&lang=js&"
export * from "./marketCourseContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9e6c4b",
  null
  
)

export default component.exports